<modal #modal>
    <div class="confirm-remove">
        <button type="button" class="confirm-remove__close" role="button" aria-label="Luk"
            aria-roledescription="Luk modal" (click)="closeModal()">
            <img src="../../../../../assets/icons/close-b.svg" />
        </button>

        <div class="confirm-remove__content text-center">
            <img src="{{iconUrl}}" class="confirm-remove__image"/>
            <h2 class="confirm-remove__heading">
                Sikker på at du vil fjerne {{isPackage ? 'lodpakke' : 'lod'}}?
            </h2>
            
            <p><span class="confirm-remove__top-prize">{{isPackage ? name : name +'-lod'}} har en topgevinst på {{topPrize}}</span><br/>Mindste gevinst {{minPrize}}</p>
            
            <div>
                <button (click)="confirmRemoval(productData)" class="cta cta--primary cta--large">Slet {{isPackage ? 'lodpakke' : 'lod'}}?</button>
            </div>
            
            <div>
                <button (click)="closeModal()" class="confirm-remove__reject">ANNULLER</button>
            </div>
        </div>
    </div>
</modal>